enum StripePricingIdsTest {
  MONTHLY = "price_1IgS36Jxfuw0gUiiBWDzdf9S",
  ANNUALLY = "price_1IgS3RJxfuw0gUii0uHXjzDR",
  QUARTERLY = "price_1LagAJJxfuw0gUiiNIT7a1nr",
  MULTI_SEAT_MONTHLY = "price_1OwQYAJxfuw0gUii4AAzVGpL",
  MULTI_SEAT_ANNUALLY = "price_1Owm6CJxfuw0gUiiJfiiYP54",
  MULTI_SEAT_MONTHLY_NOK = "price_1UI77pJxfuw0gUiivNNQafdY",
  MULTI_SEAT_ANNUALLY_NOK = "price_1UI79TJxfuw0gUiiIxThy7hk",
}
export default StripePricingIdsTest;
